var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MarkDown } from "./MarkDown";

export default class Nested extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.parseValue(this.props.value) };
  }

  parseValue(rows = []) {
    if (!rows[0]) {
      return '';
    }

    const keys = Object.keys(rows[0]).sort();
    let result = `| ${keys.join(' | ')} |\n`;
    result += `| ${keys.map(() => '-').join(' | ')} |\n`;
    result += `${rows.
    map((row) => `| ${keys.map((key) => (row[key] || []).join(',')).join(' | ')}`).
    join(' |\n')} |`;

    return result;
  }

  onChange(e) {
    const value = e.target.value || '';
    let formatedValues = [];
    this.setState({ value });
    if (value) {
      const rows = value.split('\n').filter((row) => row);
      const keys = rows[0].
      split('|').
      map((key) => key.trim()).
      filter((key) => key);
      const entries = rows.splice(2);
      formatedValues = entries.map((row) =>
      row.
      split('|').
      splice(1).
      reduce((result, val, index) => {
        if (!keys[index]) {
          return result;
        }
        const values = val.
        split(',').
        map((v) => v.trim()).
        filter((v) => v);
        result[keys[index]] = values;
        return result;
      }, {})
      );
    }

    this.props.onChange(formatedValues);
  }

  render() {
    return /*#__PURE__*/_jsx(MarkDown, { onChange: this.onChange.bind(this), value: this.state.value });
  }
}